import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { prepareScenarioConsumptionData } from "../dashboardUtils";
import { useNavigate } from "react-router-dom";
import { setState as analyzeSetState } from "../../Analyze/analyzeSlice";

export default function ScenarioConsumptionChart(props) {
  const state = useSelector((store) => store.dashboard);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { scenarioConsumption, drawerOpen } = state;
  const countryName = props.countryName;

  let scenarioConsumptionFiltered = scenarioConsumption.filter(
    (item) => item.countryName === countryName
  );

  // console.log(countryName);

  let scenarioConsumptionPrepared = [];
  scenarioConsumptionPrepared = prepareScenarioConsumptionData(
    scenarioConsumptionFiltered
  );
  const { categories, values } = scenarioConsumptionPrepared;

  const options = {
    chart: {
      id: "basic-bar",
      type: "bar",
      events: {
        dataPointSelection(event, chartContext, config) {
          handleBarChartClickEvent(
            config.w.config.series[config.seriesIndex].data[
              config.dataPointIndex
            ],
            config.w.config.xaxis.categories[config.dataPointIndex]
          );
        },
      },
    },
    title: {
      text: "Scenario Consumption Ratio",
      align: "left",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: true,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#263238",
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4,
        columnWidth: 1 * Math.log(values.length + 1) * 30 + "%",
      },
    },
    xaxis: {
      categories: [...categories],
    },
  };

  const series = [
    {
      name: "Scenario Ratio",
      data: [...values],
    },
  ];

  function handleBarChartClickEvent(consumptionRatio, scenarioName) {
    dispatch(analyzeSetState("redirectedFromDashboardScenarioConsumption", true));
    const state = {
      countryName,
      scenarioName
    }
    navigate("/analyze", { state });
  }

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      width={drawerOpen ? "100%" : "100%"}
      height={drawerOpen ? "500" : "550"}
    />
  );
}
